<template>
	<div class="m_container" :class="openType != 'mob' ? 'flex_center flex_items vh100' : ''">
		<div class="pt20 page_bg" style="box-sizing: border-box;"
			:class="openType != 'mob' ? 'container_w_h' : 'vh100'">
			<div class="bgfff mb20 plr10 pt20 pb20 mb20">
				<div class="">
					<div class="flex flex_start mb20 flex_items">
						<div class="ca6 mr10 l1" style="width: 80px;">用户名</div>
						<div class="flex1 l1">{{detail.username}}</div>
					</div>
					<div class="flex flex_start mb20 flex_items">
						<div class="ca6 mr10 l1" style="width: 80px;">姓名</div>
						<div class="flex1 l1">{{detail.name}}</div>
					</div>
					<div class="flex flex_start mb20 flex_items">
						<div class="ca6 mr10" style="width: 80px;">电话号码</div>
						<div class="flex1 l1">{{detail.phone}}</div>
					</div>
					<div class="flex flex_start flex_items">
						<div class="ca6 mr10" style="width: 80px;">角色</div>
						<div class="mr10 cf txt_center" style="width: 90px;height: 30px; line-height: 30px;border-radius: 5px;"
							:class="detail.role == 'member' ? 'gr_bg' : detail.role == 'officer' ? 'bg_blue' : 'y_bg'">
							{{detail.role == 'member' ? '会员' : detail.role == 'officer' ? '工作人员' : '管控'}}</div>
					</div>
				</div>
			</div>
			<div class="bgfff mb20 plr20 pt20 pb20">
				<div class="page_title mb20">积分详情</div>
				<div class="flex flex_between">
					<div class="txt_center">
						<div class="bold">{{detail.score ? detail.score.total : 0}}</div>
						<div class="">总积分</div>
					</div>
					<div class="txt_center">
						<div class="bold">{{detail.score ? detail.score.exchange : 0}}</div>
						<div class="">已冲销</div>
					</div>
					<div class="txt_center">
						<div class="bold">{{detail.score ? detail.score.remain: 0}}</div>
						<div class="">剩余积分</div>
					</div>
				</div>
			</div>
			<div class="bgfff flex flex_between plr20 pt20 pb20" style="border-radius: 10px 10px 0 0;">
				<div class="flex flex_column txt_center" @click="$router.push({path:'/addAccount',query:{id:id}})">
					<van-icon name="edit" class="mb10" size="40" />
					编辑
				</div>
				<div class="flex flex_column txt_center" @click="$router.push({path:'/scorelist',query:{id:id}})">
					<van-icon name="orders-o" class="mb10" size="40" />
					积分明细
				</div>
				<div class="flex flex_column txt_center" @click="re">
					<van-icon name="replay" class="mb10" size="40" />
					重置密码
				</div>
			</div>
		</div>
		<Popup v-model="show">
			<div class="bgfff pop-content b_r_10 plr20 pos">
				<van-icon name="cross" class="pop-close" size="30" @click="show = false" />
				<div class="txt_center pt20 mb20">重置密码</div>
				<div class="flex flex_items mb10 pb10 bor_b">
					<div style="width: 80px;">密码</div>
					<input type="password" v-model="password" style="width: 180px;height: 40px;" placeholder="请输入密码" />
				</div>
				<div class="flex flex_items" style="margin-bottom: 50px;">
					<div style="width: 80px;">确认密码</div>
					<input type="password" v-model="repassword" style="width: 180px;height: 40px;"
						placeholder="请输入密码" />
				</div>
				<div class="pop-btn main_bg b_r_10" @click="reN">确认重置</div>
			</div>
		</Popup>
	</div>
</template>
<script>
	import {
		openType
	} from '@/utils/tool.js'
	import {
		Dialog,Popup
	} from 'vant';
	export default ({
		components: {
			Popup
		},
		data() {
			return {
				detail: {},
				id: 1,
				openType: openType(),
				reMsg:{},
				show:false,
				repassword:'',
				password:''
			}
		},
		created() {
			this.openType = openType()
			this.id = this.$route.query.id;
			this.getList()
		},
		methods: {
			getList() {
				this.api.accountView({}, this.id).then(res => {
					this.detail = res.data
				})
			},
			re() {
				this.show = true;
			},
			// 重置
			reN() {
				if (this.password == '' || this.password != this.repassword) {
					this.Toast('密码有误')
					return
				}
				Dialog.confirm({
						title: '重置',
						message: '确定重置此密码？',
					})
					.then(() => {
						this.api.accountReset({password:this.password}, this.id).then(res => {
							this.Toast('重置成功')
							this.show = false;
						})
					})
					.catch(() => {
						// on cancel
					});
			}
		}
	})
</script>
<style scoped="scoped">
	.bg_blue{
		background-color: #C2E1FF;
		color: #3399FF;
	}
	.y_bg{
		background-color: #FFF0D1;
		color: #FF9966;
	}
	.gr_bg{
		color: #00D8CC;
		background-color: #D1F0E1;
	}
	.pop-content {
		width: 300px;
		height: 270px;
		box-sizing: border-box;
	}
	
	.pop-btn {
		width: 250px;
		margin: 0 auto;
		text-align: center;
		color: #fff;
		height: 40px;
		line-height: 40px;
	}
	
	.pop-close {
		position: absolute;
		top: 10px;
		right: 10px;
	}
</style>